/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
/* 
This is recent transactions page having transactions from operative and credit card accounts */
/* <script type="text/javascript" src="http://maps.googleapis.com/maps/api/js?sensor=false"></script> */
import {
	html,
	Polymer
} from '@polymer/polymer/polymer-legacy.js';


const template = html`
		<style include="app-styles">
			.min-height {
				min-height: 100px;
			}

			:dir(ltr) .bottom-border {
				padding-top: 8px;
				margin-right: -16px;
			}
			:dir(rtl) .bottom-border {
				padding-top: 8px;
				margin-left: -16px;
			}
			:dir(ltr) .viewTransaction {
				padding-left: 15px;
				font-size: 15px;
				visibility: hidden;
				display: none;
			}
			:dir(rtl) .viewTransaction {
				padding-right: 15px;
				font-size: 15px;
				visibility: hidden;
				display: none;
			}			
			@media (max-width:479px){
				.rt-mdl-cell {
						box-shadow: var(--shadow-elevation-1);
						border-radius: 11px;
						width:99%;
						margin: 5px auto;
				}
				.rt-primary-dark-text-m {
					color: var(--primary-color-but);
					font-size: var(--a-font-size-l);
					margin-top: 12px;
					line-height:20px;
					position: relative;
					left: -8px;
				}
				.rt-secondary-dark-text-m {
					font-size: var(--a-font-size-l);
					color: var(--primary-dark-color);	
					font-family: var(--medium-font) !important;	
					line-height:18px !important;
					margin: 8px 3px;
				}
				.rt-secondary-dark-text-s {
					font-size: var(--a-font-size-s);	
					line-height:15px;				
				}
				.rt-date {
					margin-bottom: 3px;
					margin-top: -1px;
					font-size: var(--paper-slide-font-size, medium);
					font-weight: 500;
					color: var(--primary-dark-color);
					opacity:0.93;
					line-height:18px;
					font-family: var(--medium-font) !important;
				}	
				.rt-month-date {
					margin-bottom: 3px;
					margin-top: -1px;
					font-size: var(--a-font-size-l);
					font-weight: 500;
					color: var(--primary-dark-color);
					line-height:20px;					
				}
				.rt-date-section {
					padding: 0px 13px 0px 14px;
				}	
				.rt-month-details {
					font-size: var(--a-font-size-s);
					color: var(--secondary-dark-color);					
					text-align: center;
					margin-top: 0px;
					margin-bottom: 0px;
					line-height:15px;
				}	
				.rt-div {
					/* margin-top:-16px; */
				}
				.border-b-1px {
					border-bottom: none;
					display:none;
				}
				.vl {
					    border-left: 1px solid var(--secondary-dark-color);
						height: 68px;
						opacity: 0.36;
				}
				.disp-only-in-desktop {
					display:none;
				}
				.spinner-mobile {
					display:none;
				}
				.transactions-mobile {
				  padding: 0;
				}

			}
			@media (min-width:480px){
				.rt-month-date, .rt-date-section {
					display:none;
				}
				.disp-only-in-mobile {
					display:none;
				}
			}
      .minus-sign{
        font-size: 17px;
      }
			
		</style>

		<template is="dom-if" if="{{transactionsAvailable}}">

			<app-media-query phone={{phone}} desktop={{desktop}} tablet={{tablet}}></app-media-query>

			<div class="border-b-1px" hidden$={{!phone}}>
			</div>

			<div class="mdl-grid padding-b-zero" hidden$="{{!phone}}">
				<div class="mdl-cell mdl-cell--12-col secondary-dark-text-m font-medium rt-secondary-dark-text-m">
					<oe-i18n-msg msgid="h_RecentTransactions"></oe-i18n-msg>
				</div>
			</div>

			<div>
				<template is="dom-if" if="{{recentTransactionLoader}}">
					<div class="min-height horizontal center-center layout">
						<paper-spinner id="recent_transaction_spinner" active class="spinner-mobile"></paper-spinner>
					</div>
				</template>

				<template is="dom-if" if="{{!recentTransactionLoader}}">
					<div class="mdl-grid padding-t-zero" role="list">
						<template is="dom-repeat" items="{{transactions}}">
							<div class="outlineOffset mdl-cell mdl-cell--12-col rt-mdl-cell" tabindex="0" on-keydown="downarrow" id="recentTransaction_{{index}}" role="listitem">
								<div class="outlineOffset horizontal center layout" tabindex="0">
									<!--<app-fab small image={{item.appFabImage}} name={{item.appFabName}}></app-fab>-->
									<div class="rt-date-section">
										<div><p class="rt-month-date">{{item.displayMonthDate.primaryDate}}</p></div>
										<div><p class="rt-month-details">{{item.displayMonthDate.monthName}}</p></div>
									</div>
									<div class="vl"></div>
									<div class="mdl-cell margin-t-zero margin-b-zero flex-2 text-overflow-ellipsis">
										<div class="primary-dark-text-m text-overflow-ellipsis font-medium">{{item.displayName}}&nbsp;</div>
										<div class="secondary-dark-text-xs rt-secondary-dark-text-s horizontal layout center">
											<div class="rt-div disp-only-in-mobile"> 
										    	<div><p class="rt-date"></p></div>
												<div>{{item.displayDate}}</div>
										    </div>
											<div class="rt-div disp-only-in-desktop"> 
										    	<div><p class="rt-date"></p></div>
												<div>{{item.displayMonthDate.primaryDate}} {{item.displayMonthDate.monthName}}, {{item.displayDate}}</div>
											</div>
											<div hidden$="{{!item.displayLocation}}">&nbsp;|&nbsp;
												<iron-icon class="disabled-dark-color iron-icon-style-xs" icon="location-on"></iron-icon>
											</div>
											<div class="text-overflow-ellipsis">{{item.displayLocation}}</div>
										</div>
									</div>
									<div class="vertical end layout flex-1">
										<div class="primary-dark-text-m rt-primary-dark-text-m font-medium text-overflow-ellipsis">
											<div class$="{{item.displayValueClass}}">
                        <template is="dom-if" if="{{item.displayValueSign}}" restamp=true>
                          <span class="minus-sign">&#8722; &nbsp;</span>
                        </template>
                        <!--{{item.displayValueSign}}&nbsp;-->
												<currency-formator format-value="{{item.displayValue}}"></currency-formator>
											</div>
										</div>
										<div class="secondary-dark-text-xs">&nbsp;{{item.displayTransactionTag}}</div>
									</div>
									<div index="{{index}}">
										<i class="outlineOffset fa fa-eye viewTransaction" id="drive-{{index}}" on-tap="viewDocument" tabindex="0"></i>
									</div>
								</div>
								<div class="border-b-1px bottom-border" hidden$="{{_checkLastIndex(index,transactions)}}"></div>
							</div>
						</template>
					</div>
				</template>
			</div>
		</template>`;



Polymer({
	is: 'recent-transaction',
	_template: template,
	properties: {
		/* savings */
		savings: {
			type: Array,
			notify: true,
			observer: '_savingsCardsChanged'
		},
		/* cards */
		cards: {
			type: Array,
			notify: true,
			observer: '_savingsCardsChanged'
		},
		/* transactions */
		transactions: {
			type: Array,
			value: [],
			notify: true
		},
		/* numberOfTransactions */
		numberOfTransactions: {
			type: Number,
			notify: true
		},
		/* recentTransactionLoader */
		recentTransactionLoader: {
			type: Boolean,
			value: true,
			notify: true
		},
		/* transactionsAvailable */
		transactionsAvailable: {
			type: Boolean,
			value: true,
			notify: true
		},
		/* showGoogleDrive */
		showGoogleDrive: {
			type: Boolean,
			value: false,
			notify: true
		}
	},
	/* @event _checkLastIndex
	 * event to check the length
	 */
	_checkLastIndex: function (index, transactions) {
		if (index === transactions.length - 1)
			return true;
		return false;
	},
	/**
	 * Use for one-time configuration of your component after local
	 * DOM is initialized.
	 */
	ready: function () {
		if (isDevMode()) {
			this.showGoogleDrive = true;
		}
		this.numberOfTransactions = config.SpeedBoat.App.dashboard.numberOfTransaction;
		this.dateFormat = clientStorage.get(storageType.session, "dateFormat");
		this._sortTransactions = function (tranData) {
			tranData.sort(function (a, b) {
				return getNewDate(b.transactionDate).getTime() - getNewDate(a.transactionDate).getTime();
			});
			tranData.splice(this.numberOfTransactions);
			for (var i = 0; i < tranData.length; i++) {
				tranData[i] = this._addDisplayValue(tranData[i]);
				tranData[i].appFabName = tranData[i].transactionRemarks ? tranData[i].transactionRemarks : getLabel("l_transactionCompleted");
				tranData[i].displayName = tranData[i].transactionRemarks ? tranData[i].transactionRemarks : getLabel("l_transactionCompleted");
			}
			if (tranData.length <= 0)
				this.transactionsAvailable = false;
			this.transactions = tranData;
			for (i = 0; i < this.transactions.length; i++) {
				this.getLocationDetails(this.transactions[i].displayLat, this.transactions[i].displayLng, i);
			}
			this.$$("#recent_transaction_spinner").active = false;
			this.recentTransactionLoader = false;

			//this.readDrive();
		},
			this.serviceError = function () {
				//TODO-- error handling
			}
	},
	/* @event readDrive */
	//Google Drive - @Start
  /*	readDrive: function () {
		//drive code
		if (isDevMode()) {
			var self = this;
			var getFilesPromise = this._getDriveFiles("Receipt");
			getFilesPromise.then(function (files) {
				for (var i = 0; i < self.transactions.length; i++) {
					var filePresentInDrive = false;
					for (var j = 0; j < files.length; j++) {
						if ("Receipt_" + self.transactions[i].transactionDate + ".pdf" === files[j].name) {
							self.transactions[i].googleDrive = {
								'present': true,
								'url': files[j].webViewLink
							};
							filePresentInDrive = true;
							document.getElementById("drive-" + i).style.visibility = 'visible';
							break;
						}
					}
					if (!filePresentInDrive) {
						self.transactions[i].googleDrive = {
							'present': false
						};
					}
				}
  */


	/* @event viewDocument
	 * event to view document
	 */
  /*	viewDocument: function (e) {
  		var x = screen.width / 2 - 700 / 2;
  		var y = screen.height / 2 - 450 / 2;
  		var webViewLink = this.transactions[e.currentTarget.index].googleDrive.url;
  		window.open(webViewLink, 'popUpWindow', 'height=485,width=700,left=' + x + ',top=' + y);
	},
	/* @event _getDriveFiles
	 * event to get drive files
   */
  /*
  _getDriveFiles: function () {

		return new Promise(function (resolve, reject) {

			const oauthToken = clientStorage.get(storageType.session, 'driveToken');
			var modelGetAjax = document.createElement('oe-ajax');
			modelGetAjax.handleAs = "json";
			modelGetAjax.url = 'https://www.googleapis.com/drive/v3/files';
			modelGetAjax.method = "get";

			var headers = {
				'Authorization': 'Bearer ' + oauthToken
			};
			modelGetAjax.headers = headers;

			var params = {
				q: "name contains 'Receipt_'",
				fields: '*'
			};
			modelGetAjax.params = params;
			oeAjaxEventListner(modelGetAjax);
			modelGetAjax.generateRequest();
			modelGetAjax.addEventListener('response', function (event) {
				var files = event.detail.response.files;
				resolve(files);

			});

			modelGetAjax.addEventListener('error', function (error) {
				reject(error);
			});
		});

	},
	/* @event _addDisplayValue
	 * event to display values
	 */
	//Google Drive - @End
	_addDisplayValue: function (item) {
		if (item.transactionDate != undefined && item.transactionDate != undefined) {
			item.displayDate = this._formatTime(getNewDate(item.transactionDate));
			item.displayMonthDate = this._formatDateTime(getNewDate(item.transactionDate));
		}

		if (item.locationCoordinates != undefined && item.locationCoordinates.lat != undefined && item.locationCoordinates.lng != undefined) {
			item.displayLat = parseFloat(item.locationCoordinates.lat);
			item.displayLng = parseFloat(item.locationCoordinates.lng);
		}

		//Add displayName and app-fab details
		if (item.TransactionExtension != undefined) {
			if (item.TransactionExtension.payee != undefined) {
				if (item.TransactionExtension.payee.url != undefined)
					item.appFabImage = item.TransactionExtension.payee.url;
				else
					item.appFabName = item.TransactionExtension.payee.name;
				item.displayName = item.TransactionExtension.payee.name;
			} else if (item.TransactionExtension.payer != undefined) {
				if (item.TransactionExtension.payer.url != undefined)
					item.appFabImage = item.TransactionExtension.payer.url;
				else
					item.appFabName = item.TransactionExtension.payer.name;
				item.displayName = item.TransactionExtension.payer.name;
			} else if (item.TransactionExtension.biller != undefined) {
				if (item.TransactionExtension.biller.url != undefined)
					item.appFabImage = item.TransactionExtension.biller.url;
				else
					item.appFabName = item.TransactionExtension.biller.name;
				item.displayName = item.TransactionExtension.biller.name;
			}
			if (item.TransactionExtension.locationCoordinates != undefined && item.TransactionExtension.locationCoordinates.lat != undefined && item.TransactionExtension.locationCoordinates.lng != undefined) {
				item.displayLat = parseFloat(item.TransactionExtension.locationCoordinates.lat);
				item.displayLng = parseFloat(item.TransactionExtension.locationCoordinates.lng);
			}
		} else if (item.merchant != undefined) {
			if (item.merchant.imageUrl != undefined)
				item.appFabImage = item.merchant.imageUrl;
			else
				item.appFabName = item.merchant.name;
			item.displayName = item.merchant.name;
		} else {
			item.appFabName = item.transactionRemarks;
			item.displayName = item.transactionRemarks;
		}

		//Add amount details
		if (item.amount != undefined) {
			var value = currency.symbolize(item.amount.currency + ' ' + Math.abs(item.amount.amount));
			item.displayValueSign = "";
			if (item.amountType != undefined && item.amountType.cmCode == "05")
				item.displayValueSign = "-";
			item.displayValue = value;
		} else if (item.billingAmount != undefined) {
			if (item.transactionType != undefined && item.transactionType.cmCode == "04" && item.transactionType.codeType == "TTP") {
				item.displayValueSign = "";
				item.displayValue = currency.symbolize(item.billingAmount.currency + ' ' + Math.abs(item.billingAmount.amount));
			}
			else if (item.transactionType != undefined && item.transactionType.cmCode == "05" && item.transactionType.codeType == "TTP") {
				item.displayValueSign = "-";
				item.displayValue = currency.symbolize(item.billingAmount.currency + ' ' + Math.abs(item.billingAmount.amount));
			}

		} //Add amount class details
		if (item.amountType != undefined && item.amountType.cmCode == "04") {
			item.displayValueClass = "text-brand-color";
		} else {
			item.displayValueClass = "";
		}

		//Add transaction tag details
		if (item.TransactionExtension != undefined) {
			if (item.TransactionExtension.transactionTag != undefined && Array.isArray(item.TransactionExtension.transactionTag)) {
				item.displayTransactionTag = item.TransactionExtension.transactionTag.toString();
			}
		} else if (item.transactionTag != undefined)
			item.displayTransactionTag = item.transactionTag;
		else
			item.displayTransactionTag = "";

		return item;
	},
	/* @event _savingsCardsChanged
	 * event when cards and savings change
	 */
	_savingsCardsChanged: function () {
		if (this.savings != undefined && this.cards != undefined) {
			var self = this;
			var transData = [];
			var count = 0;
			var accntLength = self.savings.length + self.cards.length;
			var accntArry = [self.savings, self.cards];

			if (accntArry[0].length > 0 || accntArry[1].length > 0) {
				accntArry.forEach(function (accounts) {
					accounts.forEach(function (accnt) {
						var ajaxCall = document.createElement('oe-ajax');
						var accountType = accnt.accountType.cmCode === "CCD" ? "creditcards" : "operativeaccounts";
						ajaxCall.contentType = "application/json";
						ajaxCall.handleAs = "json";
						ajaxCall.url = "/api/" + accountType + "/" + accnt.accountId + "/transactions?filter[order]=transactionDate%20DESC&filter[limit]=" + self.numberOfTransactions;
						ajaxCall.method = 'get';
						ajaxCall.addEventListener('response', function (event) {
							if (event.detail.response.length > 0) {
								_.forEach(event.detail.response, function (value) {
									transData.push(value);
								});
							}
							count++;
							if (count === accntLength) {
								self._sortTransactions(transData);
							}
						});
						ajaxCall.addEventListener("error", function (e) {
							count++;
							if (count === accntLength) {
								self._sortTransactions(transData);
							}
							self.serviceError(e);
						});
						oeAjaxEventListner(ajaxCall);
						ajaxCall.generateRequest();
					});
				});
			} else {
				this.transactionsAvailable = false;
				this.transactions = [];
				this.$$("#recent_transaction_spinner").active = false;
				this.recentTransactionLoader = false;
			}
		}
	},
	/* @event getLocationDetails
	 * event to get location details
	 */
	getLocationDetails: function (lat, lng, index) {
		var self = this;
		if (typeof google != "undefined" && google && google.maps) {
			var latlng = new google.maps.LatLng(lat, lng);
			var geocoder = new google.maps.Geocoder();
			if (latlng != undefined && geocoder != undefined) {
				setTimeout(function () {
					geocoder.geocode({
						'latLng': latlng
					}, function (results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							if (results[1]) {
								var location = results[1].formatted_address;
								self.set('transactions.' + index + '.displayLocation', location);
							}
						}
					});
				}, 2000 * index);
			}
		}
	},
	downarrow: function (e) {
		var indx = e.model.index;
		if (e.keyCode === 40) {
			if (this.transactions.length - 1 === e.model.index) {
				this.shadowRoot.querySelector("#recentTransaction_0").focus();
			} else {
				indx += 1;
				this.shadowRoot.querySelector("#recentTransaction_" + indx).focus();
			}
		} else if (e.keyCode === 38) {
			indx -= 1;
			this.shadowRoot.querySelector("#recentTransaction_" + indx).focus();

		}
	},
	/* @event _formatTime
	 * event to format time
	 */
	_formatTime: function (date) {
		// var hours = date.getHours();
		// var minutes = date.getMinutes();
		// var ampm = hours >= 12 ? 'PM' : 'AM';
		// hours = hours % 12;
		// hours = hours ? hours : 12;
		// minutes = minutes < 10 ? '0' + minutes : minutes;
		// var strTime = hours + ':' + minutes + ' ' + ampm;
       var strTime = moment(getNewDate(date)).format("h:mm A");
		return strTime;
	},
	_formatDateTime: function (date) {
		var dateStr = [];
		// dateStr.monthName = date.toLocaleString('default', {
		//	month: 'short'
		// });
		// dateStr.primaryDate = date.getDate();
		// dateStr.year = window.OEUtils.DateUtils.format(date, "YY");
		dateStr.primaryDate = parseInt(moment(getNewDate(date)).format('D'));
		dateStr.monthName = moment(getNewDate(date)).format('MMM');
		dateStr.year = moment(getNewDate(date)).format('YY');
		return dateStr;
	}
});